// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.11.2018 09:54:01
import { UserAccessReturnArgs_abstract } from './../../abstract/SagaBase/Defines/UserAccessReturnArgs_abstract';
export class UserAccessReturnArgs extends UserAccessReturnArgs_abstract {}
